// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';
import classNames from '@ta/common.classnames';
import { NonNavigableItem } from '@ta/list.navigable-list';

import styles from './NoResults.less';

type Props = {|
  /** Default font-size is 16px, small will be 14px */
  small?: boolean,
|};

/**
 * A simple "No Results" message for the typeahead.
 *
 * Note that this is intended to be used inside a <NavigableList/>
 */
const NoResults = (props: Props) => (
  <div className={classNames(styles.no_results, { [styles.small_font]: props.small })}>
    {localize('mobile_no_results_found_8e0')}
  </div>
);

// NavigableList should ignore this item
NoResults[NonNavigableItem] = true;

export default NoResults;
